module.exports = __webpack_public_path__ + "images/branding/ISA-SalesWerks-Certified-Level-1-White.png";